export const personaConfig = {
  nameMinChars: 1,
  nameMaxChars: 128,

  descriptionMinChars: 0,
  descriptionMaxChars: 4096,

  avatarWidth: 400,
  avatarHeight: 600,
  avatarMaxFileSizeBytes: 2e6,

  bannerWidth: 1500,
  bannerHeight: 500,
  bannerMaxFileSizeBytes: 5e6
};

/**
 * Represents the Persona resource.
 */
export interface Persona {
  id: number;
  name: string;
  description: string;
  avatar?: URL;
  banner?: URL;
  isDefault: boolean;
}

/**
 * Represents the input used for creating a new Persona resource.
 */
export interface PersonaInsert {
  name: string;
  description?: string;
  avatar?: File;
  banner?: File;
  isDefault?: boolean;
}

/**
 * Represents the input used for updating an existing Persona resource.
 */
export interface PersonaUpdate {
  id: number;
  name?: string;
  description?: string;
  avatar?: File;
  banner?: File;
  isDefault?: boolean;
}
